import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AdminLogin from '../components/AdminLogin';
import Modal from 'react-modal';

// Defina o elemento raiz para o modal (necessário para acessibilidade)
Modal.setAppElement('#root');

function AdminPage() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [fridayEvent, setFridayEvent] = useState({
    day: 'friday',
    active: false,
    flyer: "",
    pistaPrice: 0,
    camarotePrice: 0,
    camaroteOpenPrice: 0,
    pistaActive: false,
    camaroteActive: false,
    camaroteOpenActive: false
  });
  const [saturdayEvent, setSaturdayEvent] = useState({
    day: 'saturday',
    active: false,
    flyer: "",
    pistaPrice: 0,
    camarotePrice: 0,
    camaroteOpenPrice: 0,
    pistaActive: false,
    camaroteActive: false,
    camaroteOpenActive: false
  });
  const [comingSoonEvent, setComingSoonEvent] = useState({
    day: 'em_breve',
    active: false,
    flyer: "",
    type: 'em_breve'
  });

  
  const [message, setMessage] = useState('');
  const [customEvents, setCustomEvents] = useState([]); // Estado para armazenar eventos personalizados

  const [isModalOpen, setIsModalOpen] = useState(false); // Estado para controlar o modal
  const [customEvent, setCustomEvent] = useState({
    eventDate: '',
    day: '',
    pistaActive: false,
    pistaPrice: 0,
    camaroteActive: false,
    camarotePrice: 0,
    camaroteOpenActive: false,
    camaroteOpenPrice: 0,
    flyer: null
  });
  const [isManageModalOpen, setIsManageModalOpen] = useState(false); // Estado para o modal de gerenciamento
  const [isDataModalOpen, setIsDataModalOpen] = useState(false); // Estado para o modal de dados completos
  const [completeEventsData, setCompleteEventsData] = useState([]); // Estado para armazenar dados completos
  const [activeTab, setActiveTab] = useState(0); // Estado para controlar a aba ativa
  const [nameFilter, setNameFilter] = useState('all'); // Estado para filtrar nomes por tipo: 'all', 'pista', 'camarote', 'camaroteOpen'
  const [isTokenModalOpen, setIsTokenModalOpen] = useState(false);
  const [tokenInputValue, setTokenInputValue] = useState('');
  const [tokenSaveStatus, setTokenSaveStatus] = useState(null); // null | 'loading' | 'success' | 'error'

  const fetchCustomEvents = () => {
    axios.get(`${process.env.REACT_APP_API_URL}/custom-events`)
      .then(response => {
        setCustomEvents(response.data);
      })
      .catch(error => {
        console.error('Erro ao buscar eventos personalizados:', error);
        setMessage('Erro ao carregar eventos personalizados.');
      });
  };


  const openManageModal = () => {
    fetchCustomEvents(); // Carregar eventos personalizados ao abrir o modal
    setIsManageModalOpen(true);
  };

  // Fechar o modal de gerenciamento
  const closeManageModal = () => {
    setIsManageModalOpen(false);
  };

  // Função para buscar dados completos dos eventos
  const fetchCompleteEventsData = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/events/complete-data`);
      console.log('Dados recebidos do backend:', response.data);
      console.log('Primeiro evento:', response.data[0]);
      if (response.data[0] && response.data[0].names) {
        console.log('Primeiros 3 nomes do primeiro evento:', response.data[0].names.slice(0, 3));
        response.data[0].names.slice(0, 3).forEach((name, idx) => {
          console.log(`Nome ${idx + 1}:`, name, 'Tipo:', typeof name, 'É objeto?', typeof name === 'object');
          if (typeof name === 'object') {
            console.log(`  - paymentId: ${name.paymentId}`);
            console.log(`  - dateApproved: ${name.dateApproved}`);
          }
        });
      }
      setCompleteEventsData(response.data);
      setIsDataModalOpen(true);
      setActiveTab(0);
    } catch (error) {
      console.error('Erro ao buscar dados completos:', error);
      setMessage('Erro ao carregar dados completos dos eventos.');
    }
  };

  // Fechar o modal de dados completos
  const closeDataModal = () => {
    setIsDataModalOpen(false);
    setCompleteEventsData([]);
    setNameFilter('all');
  };

  const openTokenModal = () => {
    setTokenInputValue('');
    setTokenSaveStatus(null);
    setIsTokenModalOpen(true);
  };

  const closeTokenModal = () => {
    setIsTokenModalOpen(false);
    setTokenSaveStatus(null);
  };

  const handleSaveToken = async () => {
    if (!tokenInputValue.trim()) {
      setMessage('Por favor, insira o token do Mercado Pago.');
      return;
    }
    const { value: adminPassword } = await Swal.fire({
      title: 'Confirmar alteração',
      text: 'Digite a senha do administrador para confirmar a alteração do token:',
      input: 'password',
      inputPlaceholder: 'Senha do admin',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        if (!value) return 'A senha é obrigatória.';
        return null;
      }
    });
    if (!adminPassword) return;
    setTokenSaveStatus('loading');
    try {
      await axios.put(`${process.env.REACT_APP_API_URL}/settings/mercadopago-token`, {
        token: tokenInputValue.trim(),
        password: adminPassword
      });
      setTokenSaveStatus('success');
      setMessage('Token do Mercado Pago salvo com sucesso!');
      setTimeout(() => {
        closeTokenModal();
      }, 1500);
    } catch (error) {
      setTokenSaveStatus('error');
      setMessage(error.response?.data?.message || 'Erro ao salvar o token.');
    }
  };

  // Função para identificar o tipo de compra pelo nome
  const getPurchaseType = (nameObj) => {
    const name = typeof nameObj === 'string' ? nameObj : nameObj.name;
    if (name.toUpperCase().startsWith('PISTA -')) return 'pista';
    if (name.toUpperCase().startsWith('CAMAROTE OPEN -')) return 'camaroteOpen';
    if (name.toUpperCase().startsWith('CAMAROTE -')) return 'camarote';
    return 'unknown';
  };

  // Função para remover o prefixo do nome
  const cleanName = (nameObj) => {
    const name = typeof nameObj === 'string' ? nameObj : nameObj.name;
    return name.replace(/^(PISTA|CAMAROTE|CAMAROTE OPEN)\s*-\s*/i, '');
  };

  // Função para obter o nome (string ou objeto)
  // eslint-disable-next-line no-unused-vars -- reservado para uso futuro
  const getName = (nameObj) => {
    return typeof nameObj === 'string' ? nameObj : nameObj.name;
  };

  // Função para separar nomes por tipo
  const getNamesByType = (names, type) => {
    if (type === 'all') return names;
    return names.filter(nameObj => getPurchaseType(nameObj) === type);
  };

  // Função para contar nomes por tipo
  const countNamesByType = (names, type) => {
    return names.filter(nameObj => getPurchaseType(nameObj) === type).length;
  };

  // Função para formatar data
  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };


    // Função para excluir um evento personalizado
    const deleteCustomEvent = (eventId) => {
      console.log("Tentando excluir o evento com ID:", eventId); // Verificar se o evento correto está sendo passado
      if (window.confirm('Tem certeza que deseja excluir este evento?')) {
        axios.delete(`${process.env.REACT_APP_API_URL}/custom-events/${eventId}`)
          .then((response) => {
            console.log("Resposta do servidor ao excluir:", response.data); // Verificar a resposta do servidor
            setCustomEvents(customEvents.filter(event => event._id !== eventId));
            setMessage('Evento excluído com sucesso.');
          })
          .catch(error => {
            console.error('Erro ao excluir o evento:', error.response ? error.response.data : error.message); // Log mais detalhado do erro
            setMessage('Erro ao excluir o evento.');
          });
      }
    };
    
  


  const handleEventChange = (day, key, value) => {
    if (day === 'em_breve') {
      setComingSoonEvent({ ...comingSoonEvent, [key]: value });
    } else {
      const setEvent = day === 'friday' ? setFridayEvent : setSaturdayEvent;
      const event = day === 'friday' ? fridayEvent : saturdayEvent;
      setEvent({ ...event, [key]: value });
    }
  };

  const handleFileChange = (day, e) => {
    if (day === 'em_breve') {
      setComingSoonEvent({ ...comingSoonEvent, flyer: e.target.files[0] });
    } else {
      const setEvent = day === 'friday' ? setFridayEvent : setSaturdayEvent;
      const event = day === 'friday' ? fridayEvent : saturdayEvent;
      setEvent({ ...event, flyer: e.target.files[0] });
    }
  };

  const validateEvent = (event) => {
    if (event.day !== 'em_breve') {
      if (event.active && (!event.flyer || (!event.pistaActive && !event.camaroteActive && !event.camaroteOpenActive))) {
        return false;
      }
    } else {
      if (event.active && !event.flyer) {
        return false;
      }
    }
    return true;
  };

  const submitEvents = () => {
    if (!fridayEvent.active && !saturdayEvent.active && !comingSoonEvent.active) {
      // Se nenhum evento estiver ativo, limpar o banco de dados
      axios.post(`${process.env.REACT_APP_API_URL}/events/clear-all`)
        .then(() => {
          setMessage('Todos os eventos foram removidos com sucesso.');
        })
        .catch(error => {
          setMessage('Erro ao limpar eventos.');
          console.error('Erro ao limpar eventos:', error);
        });
      return;
    }

    const events = [];
    if (fridayEvent.active) {
      if (!validateEvent(fridayEvent)) {
        setMessage('Erro: Evento de sexta-feira precisa de uma imagem e pelo menos uma opção de preço.');
        return;
      }
      events.push(fridayEvent);
    }
    if (saturdayEvent.active) {
      if (!validateEvent(saturdayEvent)) {
        setMessage('Erro: Evento de sábado precisa de uma imagem e pelo menos uma opção de preço.');
        return;
      }
      events.push(saturdayEvent);
    }
    if (comingSoonEvent.active) {
      if (!validateEvent(comingSoonEvent)) {
        setMessage('Erro: Evento "EM BREVE" precisa de uma imagem.');
        return;
      }
      events.push(comingSoonEvent);
    }

    // Primeiro, apagar todos os eventos
    axios.post(`${process.env.REACT_APP_API_URL}/events/clear-all`)
      .then(() => {
        // Depois, enviar os eventos para o backend
        return Promise.all(events.map(event => {
          const formData = new FormData();
          formData.append('day', event.day);
          formData.append('type', event.type || 'regular');
          if (event.pistaActive) formData.append('pistaPrice', event.pistaPrice);
          if (event.camaroteActive) formData.append('camarotePrice', event.camarotePrice);
          if (event.camaroteOpenActive) formData.append('camaroteOpenPrice', event.camaroteOpenPrice);
          formData.append('flyer', event.flyer);

          return axios.post(`${process.env.REACT_APP_API_URL}/events`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          });
        }));
      })
      .then(responses => {
        setMessage('Eventos salvos com sucesso!');
        console.log('Eventos salvos:', responses.map(response => response.data));
      })
      .catch(error => {
        setMessage('Erro ao salvar eventos.');
        console.error('Erro ao salvar eventos:', error);
      });
  };

  const exportDayReportPDF = (day) => {
    const filename = day === 'friday' ? 'relatorio_financeiro_sexta.pdf' : 'relatorio_financeiro_sabado.pdf';
    axios.get(`${process.env.REACT_APP_API_URL}/events/financial-report-pdf/${day}`, { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        link.parentNode.removeChild(link);
      })
      .catch(error => {
        console.error(`Erro ao exportar relatório para PDF (${day}):`, error);
        setMessage(`Erro ao exportar relatório para PDF (${day}).`);
      });
  };

  const clearNames = (day) => {
    if (window.confirm(`ATENÇÃO, TODOS OS NOMES DA LISTA DE ${day.toUpperCase()} SERÃO APAGADOS. Você deseja continuar?`)) {
      axios.post(`${process.env.REACT_APP_API_URL}/events/clear-names`, { day })
        .then(response => {
          alert(response.data.message);
        })
        .catch(error => {
          alert('Erro ao apagar a lista de nomes.');
          console.error('Erro ao apagar a lista de nomes:', error);
        });
    }
  };

  const exportNames = (day) => {
    window.open(`${process.env.REACT_APP_API_URL}/events/export-names/${day}`, '_blank');
  };

  const exportNamesToExcel = (day) => {
    window.open(`${process.env.REACT_APP_API_URL}/events/export-names-excel/${day}`, '_blank');
  };

  const handleCustomEventChange = (key, value) => {
    setCustomEvent({ ...customEvent, [key]: value });
  };

  const handleCustomFileChange = (e) => {
    setCustomEvent({ ...customEvent, flyer: e.target.files[0] });
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };



  // Função para limpar os nomes do evento personalizado
const clearCustomEventNames = () => {
  if (window.confirm("ATENÇÃO, TODOS OS NOMES DO EVENTO PERSONALIZADO SERÃO APAGADOS. Você deseja continuar?")) {
    axios.post(`${process.env.REACT_APP_API_URL}/custom-events/clear-names`)
      .then(response => {
        alert(response.data.message);
      })
      .catch(error => {
        alert('Erro ao apagar a lista de nomes do evento personalizado.');
        console.error('Erro ao apagar a lista de nomes:', error);
      });
  }
};

// Função para exportar os nomes do evento personalizado em PDF
const exportCustomEventNames = () => {
  window.open(`${process.env.REACT_APP_API_URL}/custom-events/export-names`, '_blank');
};

// Função para exportar os nomes do evento personalizado em Excel
const exportCustomEventNamesToExcel = () => {
  window.open(`${process.env.REACT_APP_API_URL}/custom-events/export-names-excel`, '_blank');
};



  const handleSaveCustomEvent = () => {
    // Verificar se os campos essenciais estão preenchidos
    if (!customEvent.eventDate || !customEvent.day || !customEvent.flyer) {
      setMessage('Preencha todos os campos obrigatórios.');
      return;
    }
  
    const formData = new FormData();
    formData.append('eventDate', customEvent.eventDate);
    formData.append('day', customEvent.day);
    formData.append('flyer', customEvent.flyer);
  
    if (customEvent.pistaActive) {
      formData.append('pistaPrice', customEvent.pistaPrice);
    }
    if (customEvent.camaroteActive) {
      formData.append('camarotePrice', customEvent.camarotePrice);
    }
    if (customEvent.camaroteOpenActive) {
      formData.append('camaroteOpenPrice', customEvent.camaroteOpenPrice);
    }
  
    axios.post(`${process.env.REACT_APP_API_URL}/custom-events`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      }
    })
    .then(response => {
      setMessage('Evento personalizado salvo com sucesso!');
      console.log('Evento salvo:', response.data);
      closeModal(); // Fechar o modal após o salvamento
    })
    .catch(error => {
      setMessage('Erro ao salvar o evento.');
      console.error('Erro ao salvar o evento:', error);
    });
  };
  

  if (!isAuthenticated) {
    return <AdminLogin onLogin={setIsAuthenticated} />;
  }

  return (
    <div>
      <h1>Administração de Eventos</h1>
      <div>
        <label>
          Evento na Sexta
          <input
            type="checkbox"
            checked={fridayEvent.active}
            onChange={() => handleEventChange('friday', 'active', !fridayEvent.active)}
          />
        </label>
        {fridayEvent.active && (
          <div>
            <input
              type="file"
              onChange={(e) => handleFileChange('friday', e)}
            />
            <label>
              <input
                type="checkbox"
                checked={fridayEvent.pistaActive}
                onChange={(e) => handleEventChange('friday', 'pistaActive', e.target.checked)}
              />
              Pista
              {fridayEvent.pistaActive && (
                <input
                  type="number"
                  value={fridayEvent.pistaPrice}
                  onChange={(e) => handleEventChange('friday', 'pistaPrice', e.target.value)}
                  placeholder="Preço da Pista"
                />
              )}
            </label>
            <label>
              <input
                type="checkbox"
                checked={fridayEvent.camaroteActive}
                onChange={(e) => handleEventChange('friday', 'camaroteActive', e.target.checked)}
              />
              Camarote
              {fridayEvent.camaroteActive && (
                <input
                  type="number"
                  value={fridayEvent.camarotePrice}
                  onChange={(e) => handleEventChange('friday', 'camarotePrice', e.target.value)}
                  placeholder="Preço do Camarote"
                />
              )}
            </label>
            <label>
              <input
                type="checkbox"
                checked={fridayEvent.camaroteOpenActive}
                onChange={(e) => handleEventChange('friday', 'camaroteOpenActive', e.target.checked)}
              />
              Camarote Open
              {fridayEvent.camaroteOpenActive && (
                <input
                  type="number"
                  value={fridayEvent.camaroteOpenPrice}
                  onChange={(e) => handleEventChange('friday', 'camaroteOpenPrice', e.target.value)}
                  placeholder="Preço do Camarote Open"
                />
              )}
            </label>
          </div>
        )}
      </div>
      <div>
        <label>
          Evento no Sábado
          <input
            type="checkbox"
            checked={saturdayEvent.active}
            onChange={() => handleEventChange('saturday', 'active', !saturdayEvent.active)}
          />
        </label>
        {saturdayEvent.active && (
          <div>
            <input
              type="file"
              onChange={(e) => handleFileChange('saturday', e)}
            />
            <label>
              <input
                type="checkbox"
                checked={saturdayEvent.pistaActive}
                onChange={(e) => handleEventChange('saturday', 'pistaActive', e.target.checked)}
              />
              Pista
              {saturdayEvent.pistaActive && (
                <input
                  type="number"
                  value={saturdayEvent.pistaPrice}
                  onChange={(e) => handleEventChange('saturday', 'pistaPrice', e.target.value)}
                  placeholder="Preço da Pista"
                />
              )}
            </label>
            <label>
              <input
                type="checkbox"
                checked={saturdayEvent.camaroteActive}
                onChange={(e) => handleEventChange('saturday', 'camaroteActive', e.target.checked)}
              />
              Camarote
              {saturdayEvent.camaroteActive && (
                <input
                  type="number"
                  value={saturdayEvent.camarotePrice}
                  onChange={(e) => handleEventChange('saturday', 'camarotePrice', e.target.value)}
                  placeholder="Preço do Camarote"
                />
              )}
            </label>
            <label>
              <input
                type="checkbox"
                checked={saturdayEvent.camaroteOpenActive}
                onChange={(e) => handleEventChange('saturday', 'camaroteOpenActive', e.target.checked)}
              />
              Camarote Open
              {saturdayEvent.camaroteOpenActive && (
                <input
                  type="number"
                  value={saturdayEvent.camaroteOpenPrice}
                  onChange={(e) => handleEventChange('saturday', 'camaroteOpenPrice', e.target.value)}
                  placeholder="Preço do Camarote Open"
                />
              )}
            </label>
          </div>
        )}
      </div>
      <div>
        <label>
          Evento EM BREVE
          <input
            type="checkbox"
            checked={comingSoonEvent.active}
            onChange={() => handleEventChange('em_breve', 'active', !comingSoonEvent.active)}
          />
        </label>
        {comingSoonEvent.active && (
          <div>
            <input
              type="file"
              onChange={(e) => handleFileChange('em_breve', e)}
            />
          </div>
        )}
      </div>
      <div>
        <button onClick={openModal}>
          Adicionar evento personalizado
        </button>

        <button onClick={openManageModal}>
          Gerenciar Eventos Personalizados
        </button>

        <button onClick={fetchCompleteEventsData} style={{ backgroundColor: '#2196F3', marginLeft: '10px' }}>
          Ver Todos os Dados dos Eventos
        </button>

        <button onClick={openTokenModal} style={{ backgroundColor: '#FF9800', marginLeft: '10px' }}>
          Configurar Mercado Pago
        </button>
      </div>
      <button onClick={submitEvents}>Salvar Eventos</button>
      {message && <p>{message}</p>}

          <div className="financial-report-section">
            <h2>Relatórios Financeiros</h2>
            <button onClick={() => exportDayReportPDF('friday')}>Exportar Relatório - Sexta</button>
            <button onClick={() => exportDayReportPDF('saturday')}>Exportar Relatório - Sábado</button>
          </div>

      <h2>Gerenciar Listas de Nomes</h2>
      <button onClick={() => clearNames('friday')}>Limpar Lista de Sexta-feira</button>
      <button onClick={() => clearNames('saturday')}>Limpar Lista de Sábado</button>
      <button onClick={() => exportNames('friday')}>Exportar Nomes Confirmados para o Evento de Sexta-feira</button>
      <button onClick={() => exportNames('saturday')}>Exportar Nomes Confirmados para o Evento de Sábado</button>
      <button onClick={() => exportNamesToExcel('friday')}>Exportar Nomes para o Evento de Sexta-feira (.xlsx)</button>
      <button onClick={() => exportNamesToExcel('saturday')}>Exportar Nomes para o Evento de Sábado (.xlsx)</button>
      <h3>Evento Personalizado</h3>
      <button onClick={clearCustomEventNames}>Limpar Lista de Evento Personalizado</button>
      <button onClick={exportCustomEventNames}>Exportar Nomes Confirmados para o Evento Personalizado (PDF)</button>
      <button onClick={exportCustomEventNamesToExcel}>Exportar Nomes para o Evento Personalizado (.xlsx)</button>

      {/* Modal de Adicionar Evento Personalizado */}
      <Modal
  isOpen={isModalOpen}
  onRequestClose={closeModal}
  contentLabel="Adicionar Evento Personalizado"
  style={{
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      color: 'black',
      padding: '25px',
      transform: 'translate(-50%, -50%)'
    }
  }}
>
  <h2>Evento Personalizado</h2>
  
  {/* Data do Evento */}
  <div>
    <label>Data do Evento:</label>
    <input
      type="date"
      value={customEvent.eventDate}
      onChange={(e) => handleCustomEventChange('eventDate', e.target.value)}
    />
  </div>

  {/* Dia do Evento */}
  <div>
    <label>Dia do Evento:</label>
    <input
      type="text"
      value={customEvent.day}
      placeholder="Ex: Sexta-feira"
      onChange={(e) => handleCustomEventChange('day', e.target.value)}
    />
  </div>

  {/* Pista */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.pistaActive}
        onChange={(e) => handleCustomEventChange('pistaActive', e.target.checked)}
      />
      Pista
    </label>
    {customEvent.pistaActive && (
      <input
        type="number"
        value={customEvent.pistaPrice}
        onChange={(e) => handleCustomEventChange('pistaPrice', e.target.value)}
        placeholder="Preço da Pista"
      />
    )}
  </div>

  {/* Camarote */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.camaroteActive}
        onChange={(e) => handleCustomEventChange('camaroteActive', e.target.checked)}
      />
      Camarote
    </label>
    {customEvent.camaroteActive && (
      <input
        type="number"
        value={customEvent.camarotePrice}
        onChange={(e) => handleCustomEventChange('camarotePrice', e.target.value)}
        placeholder="Preço do Camarote"
      />
    )}
  </div>

  {/* Camarote Open */}
  <div>
    <label>
      <input
        type="checkbox"
        checked={customEvent.camaroteOpenActive}
        onChange={(e) => handleCustomEventChange('camaroteOpenActive', e.target.checked)}
      />
      Camarote Open
    </label>
    {customEvent.camaroteOpenActive && (
      <input
        type="number"
        value={customEvent.camaroteOpenPrice}
        onChange={(e) => handleCustomEventChange('camaroteOpenPrice', e.target.value)}
        placeholder="Preço do Camarote Open"
      />
    )}
  </div>

  {/* Imagem do Evento */}
  <div>
    <label>Imagem do Evento:</label>
    <input type="file" onChange={handleCustomFileChange} />
  </div>

  <button onClick={closeModal}>Fechar</button>
  <button onClick={handleSaveCustomEvent}>Salvar</button>

</Modal>

      {/* Modal de Configuração do Mercado Pago */}
      <Modal
        isOpen={isTokenModalOpen}
        onRequestClose={closeTokenModal}
        contentLabel="Configurar Token Mercado Pago"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            color: 'black',
            padding: '25px',
            transform: 'translate(-50%, -50%)',
            minWidth: '400px'
          }
        }}
      >
        <h2>Configurar Mercado Pago</h2>
        <p style={{ marginBottom: '15px', fontSize: '14px', color: '#555' }}>
          Insira o Access Token da sua conta Mercado Pago. Os pagamentos PIX serão creditados nesta conta.
        </p>
        <div style={{ marginBottom: '15px' }}>
          <label style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>Token do Mercado Pago:</label>
          <input
            type="password"
            value={tokenInputValue}
            onChange={(e) => setTokenInputValue(e.target.value)}
            placeholder="APP_USR-..."
            style={{
              width: '100%',
              padding: '10px',
              fontSize: '14px',
              boxSizing: 'border-box'
            }}
          />
        </div>
        {tokenSaveStatus === 'success' && (
          <p style={{ color: 'green', marginBottom: '10px' }}>Token salvo com sucesso!</p>
        )}
        {tokenSaveStatus === 'error' && (
          <p style={{ color: 'red', marginBottom: '10px' }}>Erro ao salvar. Verifique o token e tente novamente.</p>
        )}
        <div style={{ marginTop: '20px' }}>
          <button onClick={closeTokenModal} style={{ marginRight: '10px' }}>Cancelar</button>
          <button onClick={handleSaveToken} disabled={tokenSaveStatus === 'loading'}>
            {tokenSaveStatus === 'loading' ? 'Salvando...' : 'Salvar Token'}
          </button>
        </div>
      </Modal>

<Modal
        isOpen={isManageModalOpen}
        onRequestClose={closeManageModal}
        contentLabel="Gerenciar Eventos Personalizados"
        style={{
          content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            color: 'black',
            padding: '25px',
            transform: 'translate(-50%, -50%)'
          }
        }}
      >
        <h2>Gerenciar Eventos Personalizados</h2>

        {/* Listar eventos personalizados */}
        {customEvents.length > 0 ? (
          <ul>
            {customEvents.map(event => (
              <li key={event._id} style={{ marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                  <div>
                    <p><strong>Data:</strong> {event.eventDate}</p>
                    <p><strong>Dia:</strong> {event.day}</p>
                    <p><strong>Pista:</strong> {event.pistaPrice ? `R$${event.pistaPrice}` : 'N/A'}</p>
                    <p><strong>Camarote:</strong> {event.camarotePrice ? `R$${event.camarotePrice}` : 'N/A'}</p>
                    <p><strong>Camarote Open:</strong> {event.camaroteOpenPrice ? `R$${event.camaroteOpenPrice}` : 'N/A'}</p>
                  </div>
                  <button
                    onClick={() => deleteCustomEvent(event._id)}
                    style={{ backgroundColor: 'red', color: 'white', padding: '5px' }}
                  >
                    Excluir
                  </button>
                </div>
              </li>
            ))}
          </ul>
        ) : (
          <p>Nenhum evento personalizado disponível.</p>
        )}

        <button onClick={closeManageModal}>Fechar</button>
      </Modal>

      {/* Modal de Dados Completos */}
      <Modal
        isOpen={isDataModalOpen}
        onRequestClose={closeDataModal}
        contentLabel="Dados Completos dos Eventos"
        style={{
          content: {
            top: '1%',
            left: '1%',
            right: '1%',
            bottom: '1%',
            margin: 'auto',
            padding: '0',
            backgroundColor: '#f5f5f5',
            color: '#000000',
            borderRadius: '12px',
            maxWidth: '98%',
            maxHeight: '98%',
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          },
          overlay: {
            backgroundColor: 'rgba(0, 0, 0, 0.85)',
            zIndex: 1000
          }
        }}
      >
        {/* Cabeçalho */}
        <div style={{ 
          padding: '20px 30px', 
          backgroundColor: '#2c3e50', 
          color: '#ffffff',
          display: 'flex', 
          justifyContent: 'space-between', 
          alignItems: 'center',
          borderBottom: '3px solid #4CAF50'
        }}>
          <h2 style={{ margin: 0, fontSize: '24px', fontWeight: 'bold' }}>Dados Completos dos Eventos</h2>
          <button 
            onClick={closeDataModal} 
            style={{ 
              padding: '10px 25px', 
              cursor: 'pointer',
              backgroundColor: '#e74c3c',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              fontSize: '14px',
              fontWeight: 'bold',
              transition: 'background-color 0.3s'
            }}
            onMouseOver={(e) => e.target.style.backgroundColor = '#c0392b'}
            onMouseOut={(e) => e.target.style.backgroundColor = '#e74c3c'}
          >
            Fechar
          </button>
        </div>

        {completeEventsData.length > 0 ? (
          <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100% - 80px)', overflow: 'hidden' }}>
            {/* Abas */}
            <div style={{ 
              display: 'flex', 
              borderBottom: '2px solid #ddd', 
              backgroundColor: '#ffffff',
              padding: '0 20px',
              overflowX: 'auto',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              {completeEventsData.map((event, index) => (
                <button
                  key={index}
                  onClick={() => setActiveTab(index)}
                  style={{
                    padding: '15px 25px',
                    marginRight: '5px',
                    border: 'none',
                    borderBottom: activeTab === index ? '3px solid #4CAF50' : '3px solid transparent',
                    backgroundColor: 'transparent',
                    color: activeTab === index ? '#4CAF50' : '#666',
                    cursor: 'pointer',
                    fontWeight: activeTab === index ? 'bold' : 'normal',
                    fontSize: '14px',
                    transition: 'all 0.3s',
                    whiteSpace: 'nowrap'
                  }}
                  onMouseOver={(e) => {
                    if (activeTab !== index) {
                      e.target.style.color = '#4CAF50';
                      e.target.style.backgroundColor = '#f0f0f0';
                    }
                  }}
                  onMouseOut={(e) => {
                    if (activeTab !== index) {
                      e.target.style.color = '#666';
                      e.target.style.backgroundColor = 'transparent';
                    }
                  }}
                >
                  {event.type === 'custom' 
                    ? `Evento Personalizado - ${event.day}` 
                    : event.day === 'friday' 
                      ? 'Sexta-feira' 
                      : event.day === 'saturday' 
                        ? 'Sábado' 
                        : event.day === 'em_breve'
                          ? 'Em Breve'
                          : event.day}
                </button>
              ))}
            </div>

            {/* Conteúdo da aba ativa */}
            {completeEventsData[activeTab] && (
              <div style={{ 
                padding: '30px', 
                overflowY: 'auto',
                flex: 1,
                backgroundColor: '#ffffff'
              }}>
                {/* Layout em duas colunas */}
                <div style={{ display: 'grid', gridTemplateColumns: '350px 1fr', gap: '30px', marginBottom: '30px' }}>
                  {/* Coluna Esquerda - Informações do Evento */}
                  <div style={{ 
                    backgroundColor: '#f8f9fa', 
                    padding: '20px', 
                    borderRadius: '8px',
                    border: '1px solid #e0e0e0'
                  }}>
                    <h3 style={{ marginTop: 0, marginBottom: '20px', color: '#2c3e50', fontSize: '18px', borderBottom: '2px solid #4CAF50', paddingBottom: '10px' }}>
                      Informações do Evento
                    </h3>
                    
                    {completeEventsData[activeTab].flyer && (
                      <div style={{ marginBottom: '20px', textAlign: 'center' }}>
                        <img 
                          src={`${process.env.REACT_APP_IMAGE_URL}${completeEventsData[activeTab].flyer}`} 
                          alt="Flyer do evento" 
                          style={{ 
                            maxWidth: '100%', 
                            borderRadius: '8px',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                          }}
                        />
                      </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                      <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                        <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Tipo:</strong>
                        <span>{completeEventsData[activeTab].type === 'custom' ? 'Evento Personalizado' : 'Evento Regular'}</span>
                      </div>
                      <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                        <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Dia:</strong>
                        <span>{completeEventsData[activeTab].day}</span>
                      </div>
                      {completeEventsData[activeTab].eventDate && (
                        <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                          <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Data do Evento:</strong>
                          <span>{new Date(completeEventsData[activeTab].eventDate).toLocaleDateString('pt-BR')}</span>
                        </div>
                      )}
                      <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                        <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Status:</strong>
                        <span style={{ 
                          color: completeEventsData[activeTab].active ? '#27ae60' : '#e74c3c',
                          fontWeight: 'bold'
                        }}>
                          {completeEventsData[activeTab].active ? 'Ativo' : 'Inativo'}
                        </span>
                      </div>
                      {completeEventsData[activeTab].pistaPrice && (
                        <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                          <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Preço Pista:</strong>
                          <span style={{ color: '#27ae60', fontWeight: 'bold' }}>R$ {completeEventsData[activeTab].pistaPrice.toFixed(2)}</span>
                        </div>
                      )}
                      {completeEventsData[activeTab].camarotePrice && (
                        <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                          <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Preço Camarote:</strong>
                          <span style={{ color: '#27ae60', fontWeight: 'bold' }}>R$ {completeEventsData[activeTab].camarotePrice.toFixed(2)}</span>
                        </div>
                      )}
                      {completeEventsData[activeTab].camaroteOpenPrice && (
                        <div style={{ padding: '8px', backgroundColor: '#ffffff', borderRadius: '4px' }}>
                          <strong style={{ color: '#666', fontSize: '12px', display: 'block', marginBottom: '4px' }}>Preço Camarote Open:</strong>
                          <span style={{ color: '#27ae60', fontWeight: 'bold' }}>R$ {completeEventsData[activeTab].camaroteOpenPrice.toFixed(2)}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Coluna Direita - Nomes e Pagamentos */}
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
                    {/* Nomes Confirmados */}
                    <div style={{ 
                      backgroundColor: '#f8f9fa', 
                      padding: '20px', 
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0',
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                      minHeight: '400px'
                    }}>
                      <div style={{ marginBottom: '15px' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                          <h3 style={{ margin: 0, color: '#2c3e50', fontSize: '18px', borderBottom: '2px solid #4CAF50', paddingBottom: '10px', flex: 1 }}>
                            Nomes Confirmados
                          </h3>
                          <span style={{ 
                            backgroundColor: '#4CAF50', 
                            color: 'white', 
                            padding: '5px 15px', 
                            borderRadius: '20px',
                            fontSize: '14px',
                            fontWeight: 'bold',
                            marginLeft: '15px'
                          }}>
                            {getNamesByType(completeEventsData[activeTab].names, nameFilter).length}
                          </span>
                        </div>
                        
                        {/* Filtros por tipo de compra */}
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginBottom: '15px' }}>
                          <button
                            onClick={() => setNameFilter('all')}
                            style={{
                              padding: '8px 16px',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: nameFilter === 'all' ? 'bold' : 'normal',
                              backgroundColor: nameFilter === 'all' ? '#4CAF50' : '#e0e0e0',
                              color: nameFilter === 'all' ? 'white' : '#333',
                              transition: 'all 0.3s'
                            }}
                          >
                            Todos ({completeEventsData[activeTab].names.length})
                          </button>
                          <button
                            onClick={() => setNameFilter('pista')}
                            style={{
                              padding: '8px 16px',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: nameFilter === 'pista' ? 'bold' : 'normal',
                              backgroundColor: nameFilter === 'pista' ? '#2196F3' : '#e0e0e0',
                              color: nameFilter === 'pista' ? 'white' : '#333',
                              transition: 'all 0.3s'
                            }}
                          >
                            Pista ({countNamesByType(completeEventsData[activeTab].names, 'pista')})
                          </button>
                          <button
                            onClick={() => setNameFilter('camarote')}
                            style={{
                              padding: '8px 16px',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: nameFilter === 'camarote' ? 'bold' : 'normal',
                              backgroundColor: nameFilter === 'camarote' ? '#FF9800' : '#e0e0e0',
                              color: nameFilter === 'camarote' ? 'white' : '#333',
                              transition: 'all 0.3s'
                            }}
                          >
                            Camarote ({countNamesByType(completeEventsData[activeTab].names, 'camarote')})
                          </button>
                          <button
                            onClick={() => setNameFilter('camaroteOpen')}
                            style={{
                              padding: '8px 16px',
                              border: 'none',
                              borderRadius: '6px',
                              cursor: 'pointer',
                              fontSize: '13px',
                              fontWeight: nameFilter === 'camaroteOpen' ? 'bold' : 'normal',
                              backgroundColor: nameFilter === 'camaroteOpen' ? '#9C27B0' : '#e0e0e0',
                              color: nameFilter === 'camaroteOpen' ? 'white' : '#333',
                              transition: 'all 0.3s'
                            }}
                          >
                            Camarote Open ({countNamesByType(completeEventsData[activeTab].names, 'camaroteOpen')})
                          </button>
                        </div>
                      </div>
                      
                      <div style={{ 
                        flex: 1,
                        overflowY: 'auto', 
                        backgroundColor: '#ffffff',
                        borderRadius: '6px',
                        padding: '15px',
                        border: '1px solid #e0e0e0',
                        maxHeight: 'calc(100vh - 500px)'
                      }}>
                        {getNamesByType(completeEventsData[activeTab].names, nameFilter).length > 0 ? (
                          <div>
                            {nameFilter === 'all' ? (
                              // Exibir separado por tipo quando mostrar todos
                              <>
                                {countNamesByType(completeEventsData[activeTab].names, 'pista') > 0 && (
                                  <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ 
                                      margin: '0 0 10px 0', 
                                      color: '#2196F3', 
                                      fontSize: '16px',
                                      padding: '8px 12px',
                                      backgroundColor: '#e3f2fd',
                                      borderRadius: '4px',
                                      display: 'inline-block'
                                    }}>
                                      PISTA ({countNamesByType(completeEventsData[activeTab].names, 'pista')})
                                    </h4>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                      {completeEventsData[activeTab].names
                                        .filter(nameObj => getPurchaseType(nameObj) === 'pista')
                                        .map((nameObj, idx) => {
                                          const nameInfo = typeof nameObj === 'string' ? { name: nameObj } : nameObj;
                                          if (idx < 3) {
                                            console.log(`Renderizando nome PISTA ${idx + 1}:`, nameInfo, 'paymentId:', nameInfo.paymentId, 'dateApproved:', nameInfo.dateApproved);
                                          }
                                          return (
                                            <li 
                                              key={idx} 
                                              style={{ 
                                                padding: '12px 15px', 
                                                borderBottom: '1px solid #e0e0e0',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                transition: 'background-color 0.2s',
                                                backgroundColor: '#f8fbff'
                                              }}
                                              onMouseEnter={(e) => e.target.style.backgroundColor = '#e3f2fd'}
                                              onMouseLeave={(e) => e.target.style.backgroundColor = '#f8fbff'}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                                <span style={{ 
                                                  color: '#2196F3', 
                                                  fontWeight: 'bold',
                                                  minWidth: '40px',
                                                  fontSize: '13px'
                                                }}>
                                                  {idx + 1}.
                                                </span>
                                                <span style={{ color: '#333', fontWeight: '500' }}>{cleanName(nameInfo)}</span>
                                              </div>
                                              <div style={{ display: 'flex', gap: '15px', alignItems: 'center', fontSize: '12px', color: '#666', flexWrap: 'wrap' }}>
                                                {nameInfo.paymentId ? (
                                                  <span style={{ 
                                                    backgroundColor: '#e3f2fd',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    color: '#1976d2'
                                                  }}>
                                                    Comprovante: {nameInfo.paymentId}
                                                  </span>
                                                ) : (
                                                  <span style={{ color: '#999', fontSize: '11px' }}>Sem comprovante</span>
                                                )}
                                                {nameInfo.pixTransactionId ? (
                                                  <span style={{ 
                                                    backgroundColor: '#fff3e0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    color: '#e65100'
                                                  }}>
                                                    PIX: {nameInfo.pixTransactionId}
                                                  </span>
                                                ) : null}
                                                {nameInfo.dateApproved ? (
                                                  <span style={{ 
                                                    backgroundColor: '#f0f0f0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px'
                                                  }}>
                                                    Aprovado: {formatDate(nameInfo.dateApproved)}
                                                  </span>
                                                ) : nameInfo.paymentId ? (
                                                  <span style={{ color: '#999', fontSize: '11px' }}>Sem data</span>
                                                ) : null}
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                )}
                                
                                {countNamesByType(completeEventsData[activeTab].names, 'camarote') > 0 && (
                                  <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ 
                                      margin: '0 0 10px 0', 
                                      color: '#FF9800', 
                                      fontSize: '16px',
                                      padding: '8px 12px',
                                      backgroundColor: '#fff3e0',
                                      borderRadius: '4px',
                                      display: 'inline-block'
                                    }}>
                                      CAMAROTE ({countNamesByType(completeEventsData[activeTab].names, 'camarote')})
                                    </h4>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                      {completeEventsData[activeTab].names
                                        .filter(nameObj => getPurchaseType(nameObj) === 'camarote')
                                        .map((nameObj, idx) => {
                                          const nameInfo = typeof nameObj === 'string' ? { name: nameObj } : nameObj;
                                          return (
                                            <li 
                                              key={idx} 
                                              style={{ 
                                                padding: '12px 15px', 
                                                borderBottom: '1px solid #e0e0e0',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                transition: 'background-color 0.2s',
                                                backgroundColor: '#fffbf5'
                                              }}
                                              onMouseEnter={(e) => e.target.style.backgroundColor = '#fff3e0'}
                                              onMouseLeave={(e) => e.target.style.backgroundColor = '#fffbf5'}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                                <span style={{ 
                                                  color: '#FF9800', 
                                                  fontWeight: 'bold',
                                                  minWidth: '40px',
                                                  fontSize: '13px'
                                                }}>
                                                  {idx + 1}.
                                                </span>
                                                <span style={{ color: '#333', fontWeight: '500' }}>{cleanName(nameInfo)}</span>
                                              </div>
                                              <div style={{ display: 'flex', gap: '15px', alignItems: 'center', fontSize: '12px', color: '#666', flexWrap: 'wrap' }}>
                                                {nameInfo.paymentId ? (
                                                  <span style={{ 
                                                    backgroundColor: '#fff3e0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    color: '#f57c00'
                                                  }}>
                                                    Comprovante: {nameInfo.paymentId}
                                                  </span>
                                                ) : (
                                                  <span style={{ color: '#999', fontSize: '11px' }}>Sem comprovante</span>
                                                )}
                                                {nameInfo.pixTransactionId ? (
                                                  <span style={{ 
                                                    backgroundColor: '#fff3e0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    color: '#e65100'
                                                  }}>
                                                    PIX: {nameInfo.pixTransactionId}
                                                  </span>
                                                ) : null}
                                                {nameInfo.dateApproved ? (
                                                  <span style={{ 
                                                    backgroundColor: '#f0f0f0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px'
                                                  }}>
                                                    Aprovado: {formatDate(nameInfo.dateApproved)}
                                                  </span>
                                                ) : nameInfo.paymentId ? (
                                                  <span style={{ color: '#999', fontSize: '11px' }}>Sem data</span>
                                                ) : null}
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                )}
                                
                                {countNamesByType(completeEventsData[activeTab].names, 'camaroteOpen') > 0 && (
                                  <div style={{ marginBottom: '25px' }}>
                                    <h4 style={{ 
                                      margin: '0 0 10px 0', 
                                      color: '#9C27B0', 
                                      fontSize: '16px',
                                      padding: '8px 12px',
                                      backgroundColor: '#f3e5f5',
                                      borderRadius: '4px',
                                      display: 'inline-block'
                                    }}>
                                      CAMAROTE OPEN ({countNamesByType(completeEventsData[activeTab].names, 'camaroteOpen')})
                                    </h4>
                                    <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                      {completeEventsData[activeTab].names
                                        .filter(nameObj => getPurchaseType(nameObj) === 'camaroteOpen')
                                        .map((nameObj, idx) => {
                                          const nameInfo = typeof nameObj === 'string' ? { name: nameObj } : nameObj;
                                          return (
                                            <li 
                                              key={idx} 
                                              style={{ 
                                                padding: '12px 15px', 
                                                borderBottom: '1px solid #e0e0e0',
                                                fontSize: '14px',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'space-between',
                                                transition: 'background-color 0.2s',
                                                backgroundColor: '#faf5fc'
                                              }}
                                              onMouseEnter={(e) => e.target.style.backgroundColor = '#f3e5f5'}
                                              onMouseLeave={(e) => e.target.style.backgroundColor = '#faf5fc'}
                                            >
                                              <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                                <span style={{ 
                                                  color: '#9C27B0', 
                                                  fontWeight: 'bold',
                                                  minWidth: '40px',
                                                  fontSize: '13px'
                                                }}>
                                                  {idx + 1}.
                                                </span>
                                                <span style={{ color: '#333', fontWeight: '500' }}>{cleanName(nameInfo)}</span>
                                              </div>
                                              <div style={{ display: 'flex', gap: '15px', alignItems: 'center', fontSize: '12px', color: '#666', flexWrap: 'wrap' }}>
                                                {nameInfo.paymentId ? (
                                                  <span style={{ 
                                                    backgroundColor: '#f3e5f5',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    color: '#7b1fa2'
                                                  }}>
                                                    Comprovante: {nameInfo.paymentId}
                                                  </span>
                                                ) : (
                                                  <span style={{ color: '#999', fontSize: '11px' }}>Sem comprovante</span>
                                                )}
                                                {nameInfo.pixTransactionId ? (
                                                  <span style={{ 
                                                    backgroundColor: '#fff3e0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontWeight: 'bold',
                                                    color: '#e65100'
                                                  }}>
                                                    PIX: {nameInfo.pixTransactionId}
                                                  </span>
                                                ) : null}
                                                {nameInfo.dateApproved ? (
                                                  <span style={{ 
                                                    backgroundColor: '#f0f0f0',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px'
                                                  }}>
                                                    Aprovado: {formatDate(nameInfo.dateApproved)}
                                                  </span>
                                                ) : nameInfo.paymentId ? (
                                                  <span style={{ color: '#999', fontSize: '11px' }}>Sem data</span>
                                                ) : null}
                                              </div>
                                            </li>
                                          );
                                        })}
                                    </ul>
                                  </div>
                                )}
                              </>
                            ) : (
                              // Exibir apenas o tipo selecionado
                              <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                {getNamesByType(completeEventsData[activeTab].names, nameFilter).map((nameObj, idx) => {
                                  const nameInfo = typeof nameObj === 'string' ? { name: nameObj } : nameObj;
                                  const type = getPurchaseType(nameInfo);
                                  const typeColors = {
                                    pista: { bg: '#f8fbff', hover: '#e3f2fd', num: '#2196F3', badge: '#e3f2fd', badgeText: '#1976d2' },
                                    camarote: { bg: '#fffbf5', hover: '#fff3e0', num: '#FF9800', badge: '#fff3e0', badgeText: '#f57c00' },
                                    camaroteOpen: { bg: '#faf5fc', hover: '#f3e5f5', num: '#9C27B0', badge: '#f3e5f5', badgeText: '#7b1fa2' }
                                  };
                                  const colors = typeColors[type] || { bg: '#ffffff', hover: '#f5f5f5', num: '#4CAF50', badge: '#f0f0f0', badgeText: '#666' };
                                  
                                  return (
                                    <li 
                                      key={idx} 
                                      style={{ 
                                        padding: '12px 15px', 
                                        borderBottom: '1px solid #e0e0e0',
                                        fontSize: '14px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'space-between',
                                        transition: 'background-color 0.2s',
                                        backgroundColor: colors.bg
                                      }}
                                      onMouseEnter={(e) => e.target.style.backgroundColor = colors.hover}
                                      onMouseLeave={(e) => e.target.style.backgroundColor = colors.bg}
                                    >
                                      <div style={{ display: 'flex', alignItems: 'center', flex: 1 }}>
                                        <span style={{ 
                                          color: colors.num, 
                                          fontWeight: 'bold',
                                          minWidth: '40px',
                                          fontSize: '13px'
                                        }}>
                                          {idx + 1}.
                                        </span>
                                        <span style={{ color: '#333', fontWeight: '500' }}>{cleanName(nameInfo)}</span>
                                      </div>
                                      <div style={{ display: 'flex', gap: '15px', alignItems: 'center', fontSize: '12px', color: '#666', flexWrap: 'wrap' }}>
                                        {nameInfo.paymentId ? (
                                          <span style={{ 
                                            backgroundColor: colors.badge,
                                            padding: '4px 8px',
                                            borderRadius: '4px',
                                            fontWeight: 'bold',
                                            color: colors.badgeText
                                          }}>
                                            Comprovante: {nameInfo.paymentId}
                                          </span>
                                        ) : (
                                          <span style={{ color: '#999', fontSize: '11px' }}>Sem comprovante</span>
                                        )}
                                        {nameInfo.dateApproved ? (
                                          <span style={{ 
                                            backgroundColor: '#f0f0f0',
                                            padding: '4px 8px',
                                            borderRadius: '4px'
                                          }}>
                                            Aprovado: {formatDate(nameInfo.dateApproved)}
                                          </span>
                                        ) : nameInfo.paymentId ? (
                                          <span style={{ color: '#999', fontSize: '11px' }}>Sem data</span>
                                        ) : null}
                                      </div>
                                    </li>
                                  );
                                })}
                              </ul>
                            )}
                          </div>
                        ) : (
                          <p style={{ textAlign: 'center', color: '#999', padding: '40px' }}>
                            Nenhum nome encontrado para este filtro
                          </p>
                        )}
                      </div>
                    </div>

                    {/* Pagamentos */}
                    <div style={{ 
                      backgroundColor: '#f8f9fa', 
                      padding: '20px', 
                      borderRadius: '8px',
                      border: '1px solid #e0e0e0'
                    }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
                        <h3 style={{ margin: 0, color: '#2c3e50', fontSize: '18px', borderBottom: '2px solid #4CAF50', paddingBottom: '10px', flex: 1 }}>
                          Pagamentos
                        </h3>
                        <span style={{ 
                          backgroundColor: '#2196F3', 
                          color: 'white', 
                          padding: '5px 15px', 
                          borderRadius: '20px',
                          fontSize: '14px',
                          fontWeight: 'bold',
                          marginLeft: '15px'
                        }}>
                          {completeEventsData[activeTab].payments.length}
                        </span>
                      </div>
                      <div style={{ 
                        maxHeight: '300px', 
                        overflowY: 'auto', 
                        backgroundColor: '#ffffff',
                        borderRadius: '6px',
                        border: '1px solid #e0e0e0'
                      }}>
                        {completeEventsData[activeTab].payments.length > 0 ? (
                          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                            <thead>
                              <tr style={{ backgroundColor: '#2c3e50', color: '#ffffff' }}>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>ID Pagamento</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>ID PIX</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>Status</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>Valor</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>Data Criação</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>Data Aprovação</th>
                                <th style={{ padding: '12px', textAlign: 'left', fontSize: '13px', fontWeight: 'bold' }}>Nomes</th>
                              </tr>
                            </thead>
                            <tbody>
                              {completeEventsData[activeTab].payments.map((payment, idx) => (
                                <tr key={idx} style={{ borderBottom: '1px solid #e0e0e0' }}>
                                  <td style={{ padding: '12px', fontSize: '13px', fontWeight: 'bold', color: '#2196F3' }}>{payment.paymentId}</td>
                                  <td style={{ padding: '12px', fontSize: '12px', color: payment.pixTransactionId ? '#e65100' : '#999', fontWeight: payment.pixTransactionId ? 'bold' : 'normal' }}>
                                    {payment.pixTransactionId || 'N/A'}
                                  </td>
                                  <td style={{ padding: '12px' }}>
                                    <span style={{ 
                                      color: payment.status === 'approved' ? '#27ae60' : payment.status === 'pending' ? '#f39c12' : '#e74c3c',
                                      fontWeight: 'bold',
                                      fontSize: '12px',
                                      padding: '4px 8px',
                                      borderRadius: '4px',
                                      backgroundColor: payment.status === 'approved' ? '#d5f4e6' : payment.status === 'pending' ? '#fef5e7' : '#fadbd8'
                                    }}>
                                      {payment.status} {payment.statusDetail ? `(${payment.statusDetail})` : ''}
                                    </span>
                                  </td>
                                  <td style={{ padding: '12px', fontSize: '13px', fontWeight: 'bold', color: '#27ae60' }}>
                                    R$ {payment.transactionAmount ? payment.transactionAmount.toFixed(2) : '0.00'}
                                  </td>
                                  <td style={{ padding: '12px', fontSize: '12px', color: '#666' }}>
                                    {payment.dateCreated ? formatDate(payment.dateCreated) : 'N/A'}
                                  </td>
                                  <td style={{ padding: '12px', fontSize: '12px', color: payment.dateApproved ? '#27ae60' : '#999', fontWeight: payment.dateApproved ? 'bold' : 'normal' }}>
                                    {payment.dateApproved ? formatDate(payment.dateApproved) : 'N/A'}
                                  </td>
                                  <td style={{ padding: '12px', fontSize: '12px', color: '#666' }}>
                                    {Array.isArray(payment.names) ? payment.names.join(', ') : payment.names || 'N/A'}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        ) : (
                          <p style={{ textAlign: 'center', color: '#999', padding: '40px' }}>Nenhum pagamento encontrado</p>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div style={{ padding: '40px', textAlign: 'center' }}>
            <p style={{ fontSize: '18px', color: '#666' }}>Carregando dados...</p>
          </div>
        )}
      </Modal>

    </div>
  );
}

export default AdminPage;
